import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen bg-[#09090b] text-white flex items-center justify-center px-6">
      <div className="text-center">
        <div className="font-mono-accent text-xs uppercase tracking-[0.35em] text-zinc-500">404</div>
        <h1 className="mt-2 font-display uppercase text-5xl sm:text-6xl tracking-tight">
          Nix <span className="text-[#FF3B30]">gefunden.</span>
        </h1>
        <p className="mt-4 text-zinc-400">Die Seite existiert nicht (mehr).</p>
        <Link to="/" className="btn-primary mt-8 inline-flex h-12 px-6 items-center rounded-md">
          ZUR STARTSEITE
        </Link>
      </div>
    </main>
  );
}
